import { fetchCaratPlanningRequest } from '@/services/api/carat';
import { CaratPlanningModel } from '@/typings/models/CaratModel';
import { processAPIResponseNow } from '@/utils/request';
import { useEffect, useState } from 'react';

/**
 * The stored detail of one Carat planning (CLICKUP-86cb5zayy). The list shape
 * carries only the matched fields — the parsed export and the raw `.DAT` are a
 * few hundred kilobytes each and are fetched per planning, the first time one is
 * opened.
 */
export const useCaratPlanningDetail = (planningId?: string) => {
  const [detail, setDetail] = useState<CaratPlanningModel | undefined>();
  const [loading, setLoading] = useState(Boolean(planningId));

  useEffect(() => {
    if (!planningId) {
      setDetail(undefined);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetchCaratPlanningRequest({ planningId })
      .then((Response) => {
        processAPIResponseNow(
          Response,
          { showErrorMessage: true, onSuccess: setDetail },
          'data',
        );
      })
      .finally(() => setLoading(false));
  }, [planningId]);

  return { detail, loading };
};
